import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "../../css/entry.css";
import { BoxStyle } from "../../constantVaribles/constatanvariable";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js"
import TokenService from "../../service/TokenService";
import ToasterAlerts from "../../components/ToasterAlerts";
import dayjs from "dayjs";
import CustomTextField from "../../CustomComponant/CustomTextField ";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import SriyanshCardHeader from "../../components/CardHeader";
import EncryptService from "../../service/EncryptionService";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

import ListHeaderTableComponent from "../../CustomComponant/ListHeaderTables";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
function PaymentEntry() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [error, setError] = useState("");
  const today = dayjs();
  const [paymentDate, setpaymentDate] = useState(null);
  const [co6Number, setco6Number] = useState();
  const [co6Date, setco6Date] = useState(null);

  let poNumberFromList = state.expponumber;
  let billNumberFromList = state.expbillnumber;

  const [returnData, setreturnData] = useState([]);
  const [payreturnData, setpayreturnData] = useState([]);

  const [co7Number, setco7Number] = useState();
  const [co7Date, setco7Date] = useState(null);

  const handleClose = () => {
    navigate("../paymentlist", { replace: true });
  };

  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));
  const [errors, setErrors] = useState({});

  const InsertPOData = async (e) => {
    e.preventDefault();

    let formErrors = {};

   // if (co6dateerror) formErrors.errco6date = "Invalid CO6 Date";
   // if (co7dateerror) formErrors.errco7date = "Invalid CO7 Date";
   // if (paymentdateerror) formErrors.errpaymentdate = "Invalid Payment Date";

   if (!paymentDate) {formErrors.errpaymentdate = "Invalid Payment Date";}
   if (!co6Date) {formErrors.errco6date = "Invalid CO6 Date";}
   if (!co7Date) {formErrors.errco7date = "Invalid CO7 Date";}





    if (!co6Number || co6Number.length === 0)
      formErrors.errco6 = "Invalid CO6 Number";

    if (!co7Number || co7Number.length === 0)
      formErrors.errco7 = "Invalid CO7 Number";

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const payedt = new Date(paymentDate);
      const paydate =
        payedt.getFullYear() +
        "/" +
        parseInt(payedt.getMonth() + 1) +
        "/" +
        payedt.getDate();

      const co6dt = new Date(co6Date);
      const co6dtdate =
        co6dt.getFullYear() +
        "/" +
        parseInt(co6dt.getMonth() + 1) +
        "/" +
        co6dt.getDate();

      const co7dt = new Date(co7Date);
      const co7dtdate =
        co7dt.getFullYear() +
        "/" +
        parseInt(co7dt.getMonth() + 1) +
        "/" +
        co7dt.getDate();

      apiClient.post("/PaymentEntry", {
          vponumber: poNumberFromList,
          vbillnumber: billNumberFromList,
          vco6number: co6Number,
          vco6date: co6dtdate,
          vco7number: co7Number,
          vco7date: co7dtdate,
          vpaymentdate: paydate,
          ventryuser: uname,
          vip: ip,
        })
        .then(function (response) {
          setError(response.data);
          navigate("../paymentlist", { replace: true });
        })
        .catch(function (error) {
          if (error.response.data && error.response.data.code==='ER_DUP_ENTRY') {
          alert("Duplicate CO6 Not Allowed");
       }
     });
    }
  };

  const getdata = async (e) => {
    apiClient.post("/podetailscrn", {
        uname: uname,
        poNumber: poNumberFromList + " ",
        billnumber: billNumberFromList + " ",
      })
      .then(function (response) {
        setreturnData(response.data[0]);
      })
      .catch(function (error) {
        setError(error);
      });

    apiClient.post("/podetailspayment", {
        uname: uname,
        poNumber: poNumberFromList + " ",
        billnumber: billNumberFromList + " ",
      })
      .then(function (response) {
        setpayreturnData(response.data[0]);
      })
      .catch(function (error) {
        setError(error);
      });
  };

  useEffect(() => {
    getdata();
  },[]);

  const headers = [
    ["Indent Number", "PO Number", "Consignee"],
    ["Item Name", "Bill Date", "Paymenttype"],
    ["Bill Number", "Billed Item Qty", "Billed Value"],
    ["Bill Passing Date", "CRN Number", "CRN Date"],
    ["Hardcopy Sent to Account", "", ""],
  ];

  //
  const rows = [
    [returnData.IndentNumber, returnData.ponumber, returnData.POConsignee],
    [returnData.POItemName, returnData.billdate, returnData.paymentDesription],
    [returnData.billnumber, returnData.billitemQty, returnData.billitemValue],
    [returnData.billpassingdate, returnData.crnnumber, returnData.crndate],
    [returnData.billsenttoaccountdate, "", ""],
  ];

  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };

  return (
    <div>
    
    

      <Card className="Formcard">
        {/* {error && (
          <ToasterAlerts
            type="info"
            title="Messasge"
            errorMessage={error}
            displaytime={2000}
            handleClose={() => {
              setError("");
            }}
          />
        )} */}
  <div className="input-groupHeading">
      Payment Date

            </div>
        <CardContent>
        <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span" variant="h6">PO Details</Typography>
        </AccordionSummary>
        <AccordionDetails>
        
            <ListHeaderTableComponent headers={headers} rows={rows} />
        
        </AccordionDetails>
      </Accordion>
     

          <div className="row p-4">
            {/* ===================================================C6============================ */}

            <div className="container">
              <div className="input-group mt-2">
                <CustomTextField
                  label="CO6 Number" //set label
                  value={co6Number??''} //set value
                  onChange={(e) => {
                    setco6Number(e.target.value); //here set where value want to store
                  }}
                  placeholder="CO6 Number" //set placeholder
                  maxLength={50} // Set the maximum length
                  error={!!errors.errco6}
                  helperText={errors.errco6}
                />
              </div>

              <div className="input-group">
                <DatePickerComponent
                  label="Date of CO6"
                  id="co6date"
                  value={co6Date}
                 
                  onChange={(newDate) =>
                    handleDateChange(newDate, setco6Date)
                  } 
                  error={errors.errco6date}
                  
                  maxDate={today}
                  minDate={
                    returnData.billpassingdate
                      ? dayjs(returnData.billpassingdate)
                      : dayjs()
                  }
                />
              </div>
            </div>

            {/* ===================================================CO7============================ */}

            <div className="container">
              <div className="input-group mt-2">
                <CustomTextField
                  label="CO7 Number" //set label
                  value={co7Number??''} //set value
                  onChange={(e) => {
                    setco7Number(e.target.value); //here set where value want to store
                  }}
                  placeholder="CO7 Number" //set placeholder
                  maxLength={50} // Set the maximum length
                  error={!!errors.errco7}
                  helperText={errors.errco7}
                />
              </div>

              <div className="input-group">
                <DatePickerComponent
                  label="Date of CO7"
                  id="co7date"
                  value={co7Date}
                 
                  onChange={(newDate) =>
                    handleDateChange(newDate, setco7Date)
                  } 
                  error={errors.errco7date}
                  
                  maxDate={today}
                  minDate={
                    returnData.billpassingdate
                      ? dayjs(returnData.billpassingdate)
                      : dayjs()
                  }
                />
              </div>
            </div>

            {/* ===================================================Final Payment============================ */}

            <div className="container">
              <div className="input-group mt-2"></div>

              <div className="input-group">
                <DatePickerComponent
                  label="Final Payment  Date"
                  id="paymentDate"
                  value={paymentDate}
                  
                  onChange={(newDate) =>
                    handleDateChange(newDate, setpaymentDate)
                  } 
                  error={errors.errpaymentdate}
                  
                  maxDate={today}
                  minDate={
                    returnData.billpassingdate
                      ? dayjs(returnData.billpassingdate)
                      : dayjs()
                  }
                />
              </div>
            </div>
          </div>

          <>
            <div
              className="flex container"
              style={{
                display: "flex",
                paddingLeft: "40px",
                paddingRight: "40px",
                justifyContent: "space-between", // Distributes space between items
              }}
            >
              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={InsertPOData}
                title="Click for Data Save"
              >
                Save Data
              </button>

              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handleClose}
                title="Click for Data Save"
                style={{ backgroundColor: "red", color: "white" }}
              >
                Close
              </button>
            </div>
          </>
        </CardContent>
      </Card>
    </div>
  );
}

export default PaymentEntry;
